
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/timeline/templates/timeline"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='timeline_reset'>\n  <div class='reset_label'>Today</div>\n  <span class='sprite-global glyph-arrow'></span>\n</div>\n<div class='viewport'>\n  <div class='timeline_container'>\n    <ul class='highlights'>\n      <li class='duration animated faster'></li>\n      <li class='today'></li>\n      <li class='story'></li>\n      <li class='hover'></li>\n    </ul>\n    <div class='month-labels'></div>\n    <ul class='timeline_stream'></ul>\n  </div>\n</div>\n";
},"useData":true});
    }).call(this);
  